import { AvatarWithNotification } from '@/components/ui/avatar-with-notification';
import { User, Baby } from 'lucide-react';
import { cn, getInitials } from '@/lib/utils';

interface PersonNameProps {
  name: string;
  avatarUrl?: string | null;
  size?: 'sm' | 'md' | 'lg';
  showAvatar?: boolean;
  isChild?: boolean;
  age?: number;
  className?: string;
  isCurrentUser?: boolean;
  personId?: string;
  profileId?: string;
  showNotifications?: boolean;
}

export const PersonName = ({ 
  name, 
  avatarUrl, 
  size = 'sm', 
  showAvatar = true, 
  isChild = false,
  age,
  className,
  isCurrentUser = false,
  personId,
  profileId,
  showNotifications = true
}: PersonNameProps) => {
  // Protection contre les valeurs nulles/undefined
  if (!name || name.trim() === '') {
    return null;
  }

  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-10 w-10'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const getIcon = () => {
    if (isChild && age !== undefined) {
      return age < 13 ? <Baby className="h-3 w-3" /> : <User className="h-3 w-3" />;
    }
    return <User className="h-3 w-3" />;
  };


  return (
    <div className={cn("flex items-center gap-2", className)}>
      {showAvatar && (
        <AvatarWithNotification
          src={avatarUrl}
          alt={name}
          fallback={getInitials(name)}
          className={cn(sizeClasses[size], "border border-primary/20 bg-muted text-muted-foreground")}
          personId={personId}
          profileId={profileId}
          showNotification={showNotifications && !isCurrentUser}
        >
          {isCurrentUser && (
            <div className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-xs px-1.5 py-0.5 rounded-full font-medium">
              Moi
            </div>
          )}
        </AvatarWithNotification>
      )}
      <span className={cn("font-medium", textSizeClasses[size])}>{name}</span>
    </div>
  );
};